// extracted by mini-css-extract-plugin
module.exports = {"root":"AttachmentList_root__1gfaG","attachment":"AttachmentList_attachment__fPOGy"};